export const USER_UPDATED = 'userUpdated';